import { render, staticRenderFns } from "./optional_subject.vue?vue&type=template&id=8667ec58&"
import script from "./optional_subject.vue?vue&type=script&lang=js&"
export * from "./optional_subject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports